import React from 'react';
import { pages } from '../router/documentation';
import Routing from '../router/Routing';
const Documentation = () => {
	return <Routing routes={pages} />;
};

export default Documentation;
